// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"c8b1330e","112":"30481bbe","453":"fcadc1d9","478":"29250c21","570":"25f56863","631":"9a30c149","646":"57b08268","650":"32582ee8","943":"82155cfd"}[chunkId] + ".chunk.js";
};